import { computed } from "mobx";
import { QueryClient } from "react-query";
import { disposerTree, DisposerTree } from "./disposerTree";
import { UserInfo } from "./UserInfo";

export interface StoreStandardParams {
  getUserInfo?: () => UserInfo;
  getQueryClient?: () => QueryClient;
  parentDt: DisposerTree;
  name: string;
  [key: string]: any;
}

export class Store<T extends StoreStandardParams = StoreStandardParams> {
  constructor(standardParams: T) {
    const { getUserInfo, getQueryClient, parentDt, ...rest } = standardParams;

    this.getUserInfo = getUserInfo;
    this.getQueryClient = getQueryClient;
    this.dt = disposerTree(standardParams.name, parentDt);

    Object.entries(rest).forEach(([key, val]) => {
      this[key] = val;
    });

    if (!this.dt) throw new Error("Missing DisposerTree");
  }

  getQueryClient: () => QueryClient;
  @computed get queryClient(): QueryClient {
    return (this as any).getQueryClient();
  }

  getUserInfo: () => UserInfo;
  @computed get userInfo(): UserInfo {
    return (this as any).getUserInfo();
  }

  dt: DisposerTree;
}

export interface Store2StandardParams<T> {
  parentDt: DisposerTree;
  name: string;
  useHooks: (_this: any) => any;
}

export class Store2<T extends Store2StandardParams<T>> {
  constructor(standardParams: T) {
    const { parentDt, name, useHooks } = standardParams;

    this.dt = disposerTree(standardParams.name, parentDt);
    this.name = name;
    useHooks?.(this as any);
    this.useHooks = useHooks;

    if (!this.dt) throw new Error("Missing DisposerTree");
  }

  declare useHooks: (_this: any) => any;
  declare dt: DisposerTree;
  declare name: string;
}
